import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    marginLeft: theme.spacing(4.375),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
  },
  noteText: {
    fontSize: '14px',
    color: '#191C1D',
  },
  generalText: {
    fontSize: '14px !important',
    fontWeight: '400 !important',
    lineHeight: '20px !important',
  },
  divider: {
    width: '100%',
    marginBottom: '32px',
  },
}))
